import React from "react";
import DropzoneVSA from "../DropzoneVSA";
import background from "../assets/pvsa.png";
import DROPZONE_DATA from "../DROPZONE_DATA";
// import OpacityContext from "../OpacityContext"; //* comment out, DO NOT delete unless your sure you dont need it later
import "./productStyles.css"; //* migrate styles added by js for the products to this stylesheet

export default function P_vsa({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  //* it appears this whole export function is not using useContext(OpacityContext), lets comment this out, DO NOT DELETE
  /*const {
    bintBGOpacity,
    isBlackText,
    noBintImages,
    bintBGColor,
    lfdFile,
    pfdFile
  } = useContext(OpacityContext);*/

  const pVsaImage = {
    width: "360px",
    height: "640px",
    zIndex: "100",
    position: "absolute",
    left: "24px",
    top: "24px"
  };

  return (
    <div className="portraitProductContainer">
      <img
        alt=""
        className="backgroundImageContainer portrait"
        src={background}
      ></img>
      <div className="pVSAImage" style={pVsaImage}>
        <DropzoneVSA
          acceptedFileTypeString={DROPZONE_DATA.data.videoOnly}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="portrait"
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
    </div>
  );
}
